import React, { useEffect, useState } from "react";
import { Select } from "antd";

const { Option } = Select;

export default function MultiSelect({
  options,
  placeholder,
  controlId,
  handleMonthsChange,
  readOnly
}) {
  const [data, setData] = React.useState(options);
  const selected = data
    ?.filter((item) => item?.checked)
    .map((item) => item?.value);
  const [selectedvalues, setSelectedValues] = useState(selected);

  const handleAllChange = () => {
    const allChecked = data?.every((item) => item?.checked);
    const updatedData = data?.map((item) => ({
      ...item,
      checked: !allChecked,
    }));
    setData(updatedData);
    setSelectedValues(
      updatedData?.filter((item) => item?.checked).map((item) => item?.value)
    );
    handleMonthsChange(
      controlId,
      updatedData?.filter((item) => item?.checked).map((item) => item?.value)
    );
  };

  const handleItemChange = (value) => {
    const updatedData = data?.map((item) => ({
      ...item,
      checked: item?.value === value ? !item?.checked : item?.checked,
    }));

    setData(updatedData);
    setSelectedValues(
      updatedData?.filter((item) => item?.checked).map((item) => item?.value)
    );
    handleMonthsChange(
      controlId,
      updatedData?.filter((item) => item?.checked).map((item) => item?.value)
    );
  };

  const allSelected = data?.every((item) => item.checked);

  useEffect(() => {
    setData(options);
    const selected = options
      ?.filter((item) => item?.checked)
      .map((item) => item?.value);
    setSelectedValues(selected);
  }, [options]);

  return (
    <Select
      mode="multiple"
      className='select-and-search-container'
      placeholder={placeholder}
      showSearch={false}
      showArrow
      disabled={readOnly}
      value={selectedvalues}
      onSelect={(value) => handleItemChange(value)}
      onDeselect={(value) => handleItemChange(value)}
      dropdownRender={(menu) => (
        <>
          <div
            style={{
              padding: "8px 12px",
              cursor: "pointer",
              borderBottom: "1px solid #f0f0f0",
              fontWeight: "bold",
            }}
            onClick={handleAllChange}
          >
            {allSelected ? "Deselect All" : "Select All"}
          </div>
          {menu}
        </>
      )}
      style={{ minWidth: 120 }}
    >
      {data?.map(({ value }) => (
        <Option key={value} value={value}>
          {value}
        </Option>
      ))}
    </Select>
  );
}
